import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAdjacentAdminPath } from '../components/admin/adminNavigation';
import { vibrar } from '../utils/haptics';
import { useSwipeEntrePaginas } from './useSwipeEntrePaginas';

/**
 * Swipe horizontal entre as páginas da faixa do topo (mobile).
 *
 * O destino é sempre a aba vizinha na ordem de `getAdminNavItems()`
 * (Painel → Pedidos → Clientes → Pagos → …): arrastar para a esquerda avança,
 * para a direita volta. Nas pontas (ou em rota que não é aba) o gesto não faz
 * nada — nada de dar a volta e cair no outro extremo.
 *
 * A vibração curta existe porque o conteúdo não desliza (animar `transform`
 * na página inteira brigaria com o header fixo e com os poppers): o retorno do
 * gesto é o háptico + o chip ativo centralizado pela `AdminMobileNav`.
 *
 * @param {object} [opcoes]
 * @param {boolean} [opcoes.ativo] Só registra o gesto em telas de toque.
 * @param {boolean} [opcoes.haptic] Vibra ao trocar de página.
 */
export const useNavegacaoSwipeAdmin = ({ ativo = true, haptic = true } = {}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const onNavegar = useCallback(
    (direcao) => {
      const destino = getAdjacentAdminPath(pathname, direcao);
      if (!destino) return;

      if (haptic) vibrar('leve');
      navigate(destino);
    },
    [haptic, navigate, pathname]
  );

  return useSwipeEntrePaginas({ ativo, onNavegar });
};

export default useNavegacaoSwipeAdmin;
